import { useInitData } from '../../../../hooks'
import { getBirdviewListTarget } from '../../DashboardBirdview.utils'

// A list the NG app does not serve yet opens in the old webapp, the way the
// primary menu resolves its items.
export function useBirdviewListTarget() {
  const { availableSections } = useInitData()

  function getListTarget(target) {
    return getBirdviewListTarget({ availableSections, target })
  }

  return { getListTarget }
}
